import type { Brand } from './types'
import { brandCssVars } from './brandCssVars'

const FONT_LINK_ID = 'brand-font'
const FAVICON_ID = 'brand-favicon'

/** Aplica la marca al DOM: CSS vars, data-brand, título, favicon y fuente.
 *  Idempotente. Debe llamarse antes del primer render para evitar FOUC. */
export function applyBrand(brand: Brand): void {
  const root = document.documentElement
  const vars = brandCssVars(brand)
  for (const [key, value] of Object.entries(vars)) {
    root.style.setProperty(key, value)
  }
  root.dataset.brand = brand.id

  document.title = brand.name

  // fuente: inyecta o actualiza un único <link id="brand-font">
  let fontLink = document.getElementById(FONT_LINK_ID) as HTMLLinkElement | null
  if (!fontLink) {
    fontLink = document.createElement('link')
    fontLink.id = FONT_LINK_ID
    fontLink.rel = 'stylesheet'
    document.head.appendChild(fontLink)
  }
  if (fontLink.href !== brand.fontHref) fontLink.href = brand.fontHref

  // favicon: reutiliza el <link rel="icon"> existente (el estático de index.html)
  // o crea uno si no hay ninguno, para no dejar dos <link rel=icon> compitiendo.
  let favicon =
    (document.getElementById(FAVICON_ID) as HTMLLinkElement | null) ??
    document.querySelector<HTMLLinkElement>('link[rel~="icon"]')
  if (!favicon) {
    favicon = document.createElement('link')
    document.head.appendChild(favicon)
  }
  favicon.id = FAVICON_ID
  favicon.rel = 'icon'
  favicon.href = brand.favicon
}
